// 在main.js上通过import引入Vue库和自己写的Vue组件库
import Vue from 'vue';
import 'element-ui/lib/theme-chalk/index.css'
import element from './element/index'

Vue.use(element)

import IntvTaskCale from './components/IntvTaskCale.vue';
import eventBus from "../../../../../../util/eventBus";

(function (KDApi) {
    function MyComponent(model) {
        this._setModel(model)
    }

    MyComponent.prototype = {
        _setModel: function (model) {
            this.model = model
        },
        init: function (props) {
            console.log('-----init', this.model.style, props)
            setHtml(this.model, props)
        },
        update: function (props) {
            console.log('-----update', this.model, props)
            // updateHtml(this.model, props)
            eventBus.pub(this.model, 'update', props)
        },
        destoryed: function () {
            console.log('-----destoryed', this.model)
        }
    }

    const setHtml = (model, props) => {
        KDApi.loadFile('./css/index.css', model, () => {
            const {invoke, dom} = model;
            Vue.prototype.getLangMsg = (key, configObj) => {
                return KDApi.getLangMsg(model, key, configObj)
            }
            Vue.prototype.getZeroTime = (val) =>{
                let time = val ? new Date(val) : new Date();
                return new Date(time.getFullYear() + '/' + (time.getMonth()+1) + '/' + time.getDate()).getTime();
            }
            new Vue({
                el: model.dom,
                template: '<IntvTaskCale :invoke="invoke"  :dayData="dayData" :weekData="weekData" :monthData="monthData" :themeNum="themeNum" />',
                components: {
                    IntvTaskCale
                },
                data: {
                    dayData: [],
                    weekData: [],
                    monthData: [],
                    themeNum: "#5582F3"
                },
                destoryed() {
                    console.log('Vue destory')
                },
                mounted() {
                    if (props.themeNum) {
                        this.themeNum = props.themeNum;
                    }
                    this.updateSub = eventBus.sub(model, 'update', (props) => {
                        if (props.themeNum) {
                            this.themeNum = props.themeNum;
                        }
                        if (!props.data) {
                            return
                        }
                        if (props.data.hasOwnProperty('setDayData')) {
                            this.dayData = props.data.setDayData ? JSON.parse(props.data.setDayData) : [];
                        }
                        if (props.data.hasOwnProperty('setWeekData')) {
                            this.weekData = props.data.setWeekData ? JSON.parse(props.data.setWeekData) : [];
                        }
                        if (props.data.hasOwnProperty('setMonthData')) {
                            this.monthData = props.data.setMonthData ? JSON.parse(props.data.setMonthData) : [];
                        }
                    })
                },
                methods: {
                    invoke: function (eventName, args) {
                        invoke(eventName, args)
                    }
                }
            })
        })
    }

    // 注册自定义组件
    KDApi.register('intvTaskCale', MyComponent, {
        isMulLang: true
    })
})(window.KDApi)
